import { render, staticRenderFns } from "./SystemUser.vue?vue&type=template&id=2704ba36"
import script from "./SystemUser.vue?vue&type=script&lang=js"
export * from "./SystemUser.vue?vue&type=script&lang=js"
import style0 from "./SystemUser.vue?vue&type=style&index=0&id=2704ba36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports